import SignupForStep from './SignupForStep';
import IntroStep from './IntroStep';
import WhySophieWorksStep from './WhySophieWorksStep';
import SocialProofStep from './TestimonialsStep';
import PersonalizationSteps from './PersonalizationSteps';
import ExperienceStep from './ExperienceStep';
import CallFrequencyStep from './CallFrequencyStep';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import FormHeader from './FormHeader';
import Stepper from './Stepper';
import YourDetailsStep from './YourDetailsStep';
import FinalStep from './FinalStep';
import LovedOnePhoneStep from './LovedOnePhoneStep';
import ActivateTrialStep from './ActivateTrialStep';
import AddPaymentStep from './AddPaymentStep';
import ScheduleFirstCallStep from './ScheduleFirstCallStep';
import ThankYouStep from './ThankYouStep';

const FormContainer = () => {
    const { currentStep, totalSteps } = useSelector((state) => state.form);


    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <IntroStep />;
            case 2:
                return <SignupForStep />;
            case 3:
                return <WhySophieWorksStep />;
            case 4:
                return <SocialProofStep />;
            case 5:
                return <PersonalizationSteps />;
            case 6:
                return <ExperienceStep />;
            case 7:
                return <CallFrequencyStep />;
            case 8:
                return <YourDetailsStep />;
            case 9:
                return <FinalStep />;
            case 10:
                return <LovedOnePhoneStep />;
            case 11:
                return <ActivateTrialStep />;
            case 12:
                return <AddPaymentStep />;
            case 13:
                return <ScheduleFirstCallStep />;
            case 14:
                return <ThankYouStep />;
            default:
                return <IntroStep />;
        }
    };

    return (
        <Box minH="100vh">
            <FormHeader />
            <Stepper currentStep={currentStep} totalSteps={totalSteps} />
            <Box py={10}>{renderStep()}</Box>
        </Box>
    );
};

export default FormContainer;
